<template>
    <div class="overflow-x-hidden">
        <div v-if="loading" class="state-changed w-full h-20 fixed border-0 top-0 left-0 z-40"></div>
        
        <header-panel />

        <div class="grid sm:grid-cols-2 container mx-auto px-5 sm:px-4 text-black dark:text-dark.contentText pt-8 gap-5 mt-10 md:mt-28">
            <div class="mt-3 md:mt-10">
                <h1 style="line-height: 121.2%; font-weight:900" class="text-3xl sm:text-4xl lg:text-5xl xl:text-6xl"><div>{{ $t('main_headline_landing') }}</div> <div style="font-family: Exo, sans-serif;">Creator<span class="text-growth">X</span>one</div></h1>
                <h2 class="leading-loose mt-5 text-lg sm:text-xl lg:text-2xl xl:text-3xl">{{ $t('main_headline_landing_2') }}</h2>
                <div class="grid grid-cols-2 gap-4 w-max mt-5">
                    <button @click="dialogWindow = 'signup'" class="transition ease-in-out bg-growth rounded-xl p-2 px-6 text-white font-semibold shadow hover:shadow-light dark:shadow-dark hover:scale-105">{{ $t('for_agencies') }}</button>
                    <button @click="dialogWindow = 'signup_creator'" class="transition ease-in-out border border-growth rounded-xl p-2 px-4 text-growth font-semibold hover:shadow-light dark:shadow-dark hover:scale-105">{{ $t('for_creators') }}</button>
                </div>
            </div>
            <div class="px-5 md:px-0">
                <img alt="social media illustration" src="@/assets/images/social_media_illustration.svg" class="w-full"/>
            </div>
        </div>

        <div id="benefits" class="container mx-auto items-center pt-24 text-center relative dark:text-dark.contentText">
            <hr class="w-full border-0 border-t border-gray-300 dark:border-growth" noshade="noshade" />
            <div @click="scrollToSection('#benefits')" class="w-max cursor-pointer">
                <div class="animate-bounce text-white bg-white dark:bg-dark.bkg p-3 px-4 border-2 border-growth rounded-full absolute left-1/2 -ml-6 -mt-5">
                    <font-awesome-icon icon="fas fa-angles-down" class="text-xl text-growth" />
                </div>
            </div><br /><br />
            <span class="text-xl font-bold italic">{{ $t('step_into_our_realm') }}</span>
        </div>
        
        <transition name="zoom-fade">
            <section v-if="dialogWindow" @click="!isElectron ? (dialogWindow = false, $router.push({ path: '/', query: null })) : null" class="backdrop-blur w-full h-full fixed inset-0 bg-gray-700 bg-opacity-30 z-50 flex justify-center items-center px-4 text-black dark:text-dark.contentText">
                <section @click.stop class="rounded-lg w-full min-h-lg max-w-md sm:max-w-5xl mx-auto my-auto p-8 sm:p-12 z-50 overflow-auto relative bg-white dark:bg-dark.bkg" :class="dialogWindow == 'signup' ? '' : 'border-4 border-growth'">
                    <font-awesome-icon v-if="!isElectron || dialogWindow == 'forgot_password'" @click="dialogWindow = false, $router.push({ path: '/', query: null })" icon="fas fa-xmark" class="transition absolute p-6 top-0 right-0 text-xl cursor-pointer hover:opacity-50" />
                    <div v-if="(dialogWindow == 'signup' || dialogWindow == 'signup_creator') && signedUp == true" class="text-center">
                        <p class="text-xl font-semibold text-xl">{{ $t('reg_success') }}</p>
                        <p class="mt-7 text-lg font-semibold">{{ $t('reg_request_1') }}</p>
                        <p class="mt-3 italic text-lg">{{ $t('reg_request_2') }}</p>
                    </div>
                    <slot v-else-if="dialogWindow == 'forgot_password'">
                        <div class="grid sm:grid-cols-2 gap-5">
                            <img src="@/assets/images/undraw_forgot-password_odai.svg" class="w-full h-24 mx-auto sm:h-48 mx-auto px-3 sm:px-0" />
                            <Transition name="fade" mode="out-in">
                                <section>
                                    <div v-if="!enterResetCode">
                                        <h2 class="text-2xl font-black mb-1">{{ $t('forgot_password') }}</h2>
                                        <p class="leading-relaxed mb-4">{{ $t('forgot_password_desc') }}</p>
                                        <form @submit.prevent="handleSubmit">
                                            <MazInput v-model="fData.email" autocomplete="off" :label="$t('reg_form.email')" />
                                            <div v-html="errorMessageContent" class="mt-2 text-red-400 text-sm"></div>
                                            <button type="submit" @click="resetPasswordEmail()" class="mt-2 transition ease-in-out bg-growth rounded-xl p-2 px-6 text-white font-semibold shadow hover:shadow-light dark:shadow-dark hover:scale-105">
                                                <font-awesome-icon v-if="buttonLoading" icon="fas fa-spinner" class="animate-spin mr-2" /> 
                                                {{ $t('submit') }}
                                            </button>
                                        </form>
                                    </div>
                                    <div v-else-if="enterResetCode && resetCode.length == 4 && resetCodeSuccess">
                                        <h2 class="text-2xl font-black mb-1">{{ $t('forgot_password') }}</h2>
                                        <p class="leading-relaxed mb-4">{{ $t('reg_form.forgot_password_new_pass_desc') }}</p>
                                        <MazInput v-model="fData.password" autocomplete="off" :label="$t('reg_form.password')" type="password" class="mb-2" />
                                        <MazInput v-model="fData.password_again" autocomplete="off" :label="$t('reg_form.confirm_password')" type="password" />
                                        <div v-html="errorMessageContent" class="mt-2 text-red-400 text-sm"></div>
                                        <button type="submit" @click="resetPassword()" class="mt-2 transition ease-in-out bg-growth rounded-xl p-2 px-6 text-white font-semibold shadow hover:shadow-light dark:shadow-dark hover:scale-105">
                                            <font-awesome-icon v-if="buttonLoading" icon="fas fa-spinner" class="animate-spin mr-2" /> 
                                            {{ $t('submit') }}
                                        </button>
                                    </div>
                                    <div v-else>
                                        <h2 class="text-2xl font-black mb-1">{{ $t('forgot_password') }}</h2>
                                        <p class="leading-relaxed mb-4">{{ $t('forgot_password_code_desc') }}</p>
                                        <MazInputCode v-model="resetCode" ref="resetCodeInput"/>
                                        <div v-html="errorMessageContent" class="mt-2 text-red-400 text-sm"></div>
                                    </div>
                                    <button v-if="enterResetCode" @click="clearResetProcess()" class="mt-3 rounded-xl text-textOnBkg dark:text-dark.textOnBkg font-light text-sm">Return</button>
                                </section>
                            </Transition>
                        </div>
                        
                    </slot>
                    <slot v-else>
                        <div class="grid md:grid-cols-2 gap-x-10">
                            <div class="hidden md:block">
                                <h2 class="text-2xl font-black mb-5">{{dialogText.h1}}</h2>
                                <p class="leading-relaxed">{{dialogText.p1}}</p>
                                <br />
                                <h2 class="text-2xl font-black mb-5 mt-5">{{dialogText.h2}}</h2>
                                <ul class="list-disc ml-6 leading-relaxed">
                                    <li>{{ $t('reg_form.reg_benefit_1') }}</li>
                                    <li>{{ $t('reg_form.reg_benefit_2') }}</li>
                                    <li>{{ $t('reg_form.reg_benefit_3') }}</li>
                                    <li>{{ $t('reg_form.reg_benefit_4') }}</li>
                                </ul>
                                <div v-if="dialogWindow == 'signup' || dialogWindow == 'signup_creator'" class="mt-5">
                                    <strong class="text-lg" v-html="$t('reg_form.begin_trial')"></strong>
                                    <br />{{ $t('reg_form.begin_trial_desc') }}
                                </div>
                            </div>
                            <div>
                                <h2 v-if="dialogWindow == 'signup'" class="font-black text-xl mb-5 leading-none">{{ $t('sign_up') }} <br /><span class="text-sm font-light">{{ $t('for_an') }} {{ $t('agency_account') }}</span></h2>
                                <h2 v-if="dialogWindow == 'signup_creator'" class="font-black text-xl mb-5 leading-none">{{ $t('sign_up') }} <br /><span class="text-sm font-light">{{ $t('for_an') }} {{ $t('creator_account') }}</span></h2>
                                <h2 v-if="dialogWindow == 'signin'" class="font-black text-xl mb-5 leading-none">{{ $t('sign_in') }} <br /><span class="text-sm font-light">{{ $t('to_your') }} {{ $t('agency_account') }}</span></h2>
                                <form @submit.prevent="handleSubmit">
                                    <transition-group name="fade-transition" tag="div" class="relative">
                                        <div class="mt-3" key="signin-form">
                                            <MazInput 
                                                v-model="fData.email" autocomplete="off" 
                                                :label="$t('reg_form.email')"
                                                 @input="fData.email"
                                            />
                                        </div>
                                        <div class="mt-3" key="signin-form">
                                            <MazInput 
                                                v-model="fData.password" autocomplete="off" 
                                                :label="$t('reg_form.password')"
                                                type="password"
                                            />
                                        </div>
                                        <div v-if="dialogWindow == 'signin'" class="text-sm mt-2 cursor-pointer font-light text-sm" @click="dialogWindow = 'forgot_password'">
                                            {{ $t('forgot_password') }}
                                        </div>
                                        <div class="mt-3" v-if="dialogWindow == 'signup' || dialogWindow == 'signup_creator'" key="signup-form">
                                            <MazInput 
                                                v-model="fData.password_again" autocomplete="off" 
                                                :label="$t('reg_form.confirm_password')"
                                                type="password"
                                            />
                                        </div>
                                        <div class="mt-3" v-if="dialogWindow == 'signup' || dialogWindow == 'signup_creator'" key="signup-form">
                                            <MazPhoneNumberInput
                                                v-model="fData.phone_number"
                                                v-model:country-code="countryCode"
                                                show-code-on-list
                                                @update="results = $event"
                                            />
                                        </div>
                                        <div class="mt-3" v-if="dialogWindow == 'signup' || dialogWindow == 'signup_creator'" key="signup-form">
                                            <MazInput 
                                                v-model="fData.name" autocomplete="off" 
                                                :label="dialogWindow == 'signup_creator' ? $t('reg_form.creator_name') : $t('reg_form.agency_name')"
                                            />
                                        </div>
                                        <div class="mt-3" v-if="dialogWindow == 'signup'" key="signup-form">
                                            <MazInput 
                                                v-model="fData.url" autocomplete="off" 
                                                :label="$t('reg_form.agency_url')"
                                            />
                                        </div>
                                        <div class="mt-3 cursor-pointer" v-if="dialogWindow == 'signup' || dialogWindow == 'signup_creator'" @click="fData.tos = !fData.tos" key="signup-form">
                                            <font-awesome-icon :icon="fData.tos == true ? 'fas fa-check-square' : 'far fa-square'" class="text-growth text-lg" /> &nbsp;{{ $t('reg_form.terms_1') }} <a href="/tos" target="_blank" class="underline">{{ $t('reg_form.terms_2') }}</a>
                                        </div>
                                    </transition-group>
                                    <div v-html="errorMessageContent" class="mt-2 text-red-400 text-sm"></div>
                                    <button type="submit" @click="submitForm()" class="mt-2 transition ease-in-out bg-growth rounded-xl p-2 px-6 text-white font-semibold shadow hover:shadow-light dark:shadow-dark hover:scale-105">
                                        <font-awesome-icon v-if="buttonLoading" icon="fas fa-spinner" class="animate-spin mr-2" /> 
                                        {{dialogWindow == 'signup' || dialogWindow == 'signup_creator' ? $t('submit') : $t('log_in') }}
                                    </button>
                                </form>
                                <div v-if="dialogWindow == 'signup'" class="mt-5 text-sm font-light">{{ $t('reg_form.question_1') }} <u class="font-normal cursor-pointer" @click="dialogWindow = 'signin'">{{ $t('log_in') }}</u></div>
                                <div v-if="dialogWindow == 'signin'" class="mt-5 text-sm font-light">{{ $t('reg_form.question_2') }} <u class="font-normal cursor-pointer" @click="dialogWindow = 'signup'">{{ $t('sign_up') }}</u></div>
                            </div>
                        </div>
                    </slot>
                </section>
            </section>
        </transition>
        
        <benefits-panel />
        <div id="pricing">
            <pricing />
        </div>
        <div id="reviews">
            <reviews />
        </div>
        <footer-panel />

        <transition name="fade">
            <button v-if="isVisible" class="animate-bounce fixed bottom-6 left-1/2 -ml-6 bg-growth bg-opacity-10 hover:bg-opacity-30 border border-growth rounded-full text-growth h-12 w-12 z-30" @click="scrollToTop">
                <font-awesome-icon icon="fas fa-arrow-up" />
            </button>
        </transition>
    </div>
</template>

<script>
    import { signup, api_get_call } from "@/api/api"
    import logoComponent from "@/components/logo.vue"
    import pricing from "@/components/landing/pricing.vue"
    import reviews from "@/components/landing/reviews.vue"
    import BenefitsPanel from "@/components/landing/BenefitsLanding.vue"
    import FooterPanel from "@/components/landing/FooterLanding.vue"
    import languagePicker from "@/components/languagePicker.vue"
    import headerPanel from "@/components/landing/HeaderLanding.vue";
    import { useAuthStore } from '@/stores/auth';

    export default {
        components: {
            BenefitsPanel,FooterPanel,pricing,reviews,logoComponent, languagePicker, headerPanel
        },
        data() {
            return {
                isElectron: this.$cookies.get('desktop_app_token') == import.meta.env.VITE_API_INTERNAL_KEY_LIST,
                openSignupOptions:false,
                displayPass:false,
                menuOpen:false,
                theme:false,
                enterResetCode: false,
                resetCode: '',
                resetCodeSuccess: false,
                countryCode:null,
                showPassword:false,
                warning:false,
                fData: {
                    email: null,
                    password: null,
                    password_again: null,
                    name: null,
                    url: null,
                    phone_number: null,
                    tos: false,
                    type: 'agency'
                },
                loading: false,
                buttonLoading:false,
                errorMessage: false,
                errorMessageContent: null,
                permissions:null,
                isVisible: false,
                dialogWindow: false,
                signedUp: this.$route.query.signedUp == 'true' ? true : false,
                mode: document.documentElement.classList.contains('dark') ? 'dark' : 'light',
                icon: document.documentElement.classList.contains('dark') ? 'fa-solid fa-sun' : 'fa-solid fa-moon',
            }
        },
        watch: {
            '$route.query.open': function(newVal) {
                if (newVal === 'register') {
                    this.dialogWindow = 'signup';
                }
                if (newVal === 'signup_creator') {
                    this.dialogWindow = 'signup_creator';
                }
                if (newVal === 'login') {
                    this.dialogWindow = 'signin';
                    this.open_login_modal();
                }
                if (newVal === 'benefits') {
                    this.scrollToSection('#benefits');
                }
                if (newVal === 'pricing') {
                    this.scrollToSection('#pricing');
                }
            },
            resetCode: function(newVal) {
                if (newVal.length == 4) {
                    //validate the code
                    this.$axios.post("login/", {
                        email: this.fData.email,
                        verificationCode: newVal,
                        action: 'validate_reset_code'
                    }).then((result) => {
                        this.resetCodeSuccess = result.data.success;
                        if (result.data.success) {
                            this.errorMessageContent = null;
                        } else {
                            this.errorMessageContent = result.data?.message ?? this.$t('reg_form.code_invalid');
                        }
                    }, (error) => {
                        console.log(error);
                    });
                }
            }
        },
        computed: {
            dialogText() {
                if (this.dialogWindow == 'signup' || this.dialogWindow == 'signup_creator') {
                    return {
                        h1: this.$t('reg_form.headline_1'),
                        p1: this.$t('reg_form.p1'),
                        h2: this.$t('reg_form.headline_2')
                    }
                } else {
                    return {
                        h1: this.$t('reg_form.headline_3'),
                        p1: this.$t('reg_form.p2'),
                        h2: this.$t('reg_form.headline_4')
                    }
                }
            }
        },
        methods: {
            clearResetProcess() {
                this.enterResetCode = false;
                this.resetCode = '';
                this.resetCodeSuccess = false;
                this.errorMessageContent = null;
            },
            resetPasswordEmail() {
                // Email format regex
                const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
                // Check if this.fData.email is not empty and is a valid email
                if (!this.fData.email || !emailRegex.test(this.fData.email)) {
                    this.errorMessageContent = this.$t('reg_form.warning_1');
                    this.buttonLoading = false;
                } else {
                    this.$axios.post("login/", {
                        email: this.fData.email,
                        action: 'forgot_password'
                    }).then((result) => {
                        if (result.data.success) {
                            this.errorMessageContent = null;
                            this.enterResetCode = true;

                            this.$nextTick(() => {
                                setTimeout(() => {
                                    const input = this.$refs.resetCodeInput.$el.querySelector('input');
                                    if (input) {
                                    input.focus();
                                    }
                                }, 100); // Adjust delay as needed (100ms is usually enough)
                            });
                        } else {
                            this.errorMessageContent = result.data?.error ?? this.$t('reg_form.reset_password_error');
                            return;
                        }
                    }, (error) => {
                        console.log(error);
                    });
                }
            },
            resetPassword() {
                //check password and password_again are the same
                if (this.fData.password !== this.fData.password_again) {
                    this.errorMessageContent = this.$t('reg_form.warning_3');
                    this.buttonLoading = false;
                    return;
                }
                //check the length of the password - at least 8 chars
                if (this.fData.password.length < 8) {
                    this.errorMessageContent = this.$t('reg_form.warning_2');
                    this.buttonLoading = false;
                    return;
                }
                this.$axios.post("login/", {
                    email: this.fData.email,
                    verificationCode: this.resetCode,
                    password: this.fData.password,
                    action: 'reset_password'
                }).then((result) => {
                    if (result.data.success) {
                        //login based on result - use the token
                        this.login();
                    } else {
                        this.errorMessageContent = this.$t('reg_form.reset_password_error');
                    }
                }, (error) => {
                    console.log(error);
                });
            },
            toggleDarkMode() {
                this.mode = this.mode === 'light' ? 'dark' : 'light';
                this.icon = this.icon === 'fa-solid fa-moon' ? 'fa-solid fa-sun' : 'fa-solid fa-moon';
                const html = document.documentElement; // Or document.body
                html.classList.toggle('dark');
                localStorage.setItem("darkMode", this.mode.toString() === 'dark');
            },
            gtagReportConversion() {
                try {
                    // Ensure gtag is loaded and functional
                    let callback = function () {
                        console.log("Conversion reported successfully.");
                    }
                    if (typeof gtag === "function") {
                        gtag("event", "conversion", {
                            send_to: "AW-11491577916/hhfdCLu-rfYZELygzucq",
                            value: 1.0, 
                            currency: 'EUR', 
                            event_callback: callback
                        });
                    } else {
                        console.log("gtag function is not available. Make sure Google Tag Manager is properly initialized.");
                    }
                } catch (error) {
                    console.error("Error in gtagReportConversion: ", error);
                }
            },
            async open_login_modal() {
                if (this.$cookies.get('userToken')) {
                    if (!(this.$cookies.get('c_id'))) {
                    var companyID = null;
                    } else {
                        var companyID = this.$cookies.get('c_id');
                    }
                    
                    this.$axios.get("opravnenia/userToken.php", {
                        params: {
                            userToken: this.$cookies.get('userToken'),
                            companyID: companyID
                        }
                        }).then(async (result) => {
                            if (result.data.selectBranch) {
                                let prev = this.$route.path;
                                this.$router.push({name:'Profile', query: { prevRoute: prev } });
                            } else if ((result.data.logout) && (this.$router.currentRoute._rawValue.fullPath != "/Login") && (result.data.selectBranch != true)) {
                                this.$cookies.remove('userToken');
                                if (this.isElectron && typeof window.electron !== 'undefined') {
                                    await window.electron.saveToken('');
                                }
                            }
                            this.permissions = result.data.new_permissions??null;
                            if (this.isElectron) {
                                this.$router.push({name: 'Creators'});
                            } else {
                                this.$router.push({name: 'Profile'})
                            }
                        }, (error) => {
                        console.log(error);
                    })
                }
                this.dialogWindow = 'signin';
            },
            scrollToSection(target) {
                this.$router.push(target).catch(err => {
                    if (err.name != "NavigationDuplicated" && !err.message.includes("Avoided redundant navigation to current location")) {
                        console.log(err);
                    }
                });
            },
            eyeIcon(condition) {
                return !condition ? 'fas fa-eye' : 'fas fa-eye-slash';
            },
            async signupLocal() {
                this.errorMessageContent = "";

                // Email format regex
                const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

                // Validation checks
                if (!this.fData.email || !emailRegex.test(this.fData.email)) {
                    this.errorMessageContent = this.$t('reg_form.warning_1');
                    this.buttonLoading = false;
                } else if (!this.fData.password || this.fData.password.length < 8) {
                    // Checks if password is not null, undefined, or less than 8 characters
                    this.errorMessageContent = this.$t('reg_form.warning_2');
                    this.buttonLoading = false;
                } else if (this.fData.password !== this.fData.password_again || !this.fData.password_again) {
                    // Checks if both passwords do not match or if password_again is not entered
                    this.errorMessageContent = this.$t('reg_form.warning_3');
                    this.buttonLoading = false;
                } else if (!this.fData.name) {
                    // Checks if the agency name is not entered
                    this.errorMessageContent = this.$t('reg_form.warning_4');
                    this.buttonLoading = false;
                } else if (!this.fData.tos) {
                    // Checks if the Terms of Service is not agreed to
                    this.errorMessageContent = this.$t('reg_form.warning_5');
                    this.buttonLoading = false;
                } else if (!this.fData.phone_number) {
                    this.errorMessageContent = this.$t('reg_form.warning_6');
                    this.buttonLoading = false;
                }

                if (this.dialogWindow == 'signup_creator') {
                    this.fData.type = 'creator';
                }

                // If there are any error messages, don't proceed with signup
                if (this.errorMessageContent) {
                    this.warning = true; // You might want to use this flag to show the error messages in your template
                    return; // Stop the function if any validations fail
                }

                this.gtagReportConversion();
                const signupResult = await signup(this.fData);
                if (!signupResult.success) {
                    this.errorMessageContent = signupResult.message;
                    setTimeout(() => {
                        this.buttonLoading = false;
                    }, 200);
                } else {
                    //generate the purchase link here with trial period
                    this.authMemory(signupResult.token);
                    
                    setTimeout(() => {
                        this.buttonLoading = false;
                    }, 200);
                }
            },
            submitForm() {
                this.buttonLoading = true;
                if (this.dialogWindow == 'signin') { 
                    this.login();
                    setTimeout(() => {
                        this.buttonLoading = false;
                    }, 200);
                }
                if (this.dialogWindow == 'signup') { this.signupLocal();}
                if (this.dialogWindow == 'signup_creator') { this.signupLocal();}
            },
            eyeIcon(condition) {
                return !condition ? 'fas fa-eye' : 'fas fa-eye-slash';
            },
            scrollToTop() {
                window.scrollTo({
                    top: 0,
                    behavior: 'smooth',
                });
            },
                // Method to check the scroll position and update the `isVisible` property
            checkScroll() {
                this.isVisible = window.scrollY > 100;
            },
            async should_go_to_profile(token = this.$cookies.get('userToken')) {
                this.agency_status = await api_get_call(`users/?action=agency_profile_status&companyID=${this.$cookies.get('c_id')}&userToken=${token}`);
                //condition if exact tasks id=1 and id=2 are done. If not, redirect to profile page
                let profile_done_status = (this.agency_status.to_do.filter(task => task.done).length / this.agency_status.to_do.length * 100).toFixed(0);
                return profile_done_status < 100;
            },
            async authMemory(token) {
                this.$cookies.set('c_id', null, '14d');
                this.$cookies.set('userToken', token, '14d');

                // Save token in Electron if applicable
                if (this.isElectron && typeof window.electron !== 'undefined') {
                    await window.electron.saveToken(token);
                }

                // Update the authentication store (if you’re using one, e.g., Pinia or Vuex)
                const authStore = useAuthStore(); // Adjust based on your store setup
                if (authStore && typeof authStore.initialize === 'function') {
                    await authStore.initialize(); // Ensure the store fetches user data with the new token
                }

                // Check profile condition and navigate
                const go_to_profile = await this.should_go_to_profile(token);

                if (this.isElectron && go_to_profile) {
                    await this.$router.push({ name: 'Creators' });
                } else {
                    await this.$router.push({ name: 'Profile' });
                }
            },
            async login() {
                this.loading = true;
                try {
                    // Make the login API call
                    const result = await this.$axios.post("login/", {
                        email: this.fData.email,
                        password: this.fData.password
                    });

                    this.permissions = result.data.new_permissions ?? null;

                    if (result.data.success) {
                        // Set the cookie
                        this.authMemory(result.data.token);
                    } else {
                        this.errorMessage = true;
                        this.errorMessageContent = result.data.error === 'account-deactivated'
                            ? this.$t('reg_form.error_1')
                            : this.$t('reg_form.error_2');
                    }
                } catch (error) {
                    console.error('Login failed:', error);
                    this.errorMessage = true;
                    this.errorMessageContent = this.$t('reg_form.error_2');
                } finally {
                    this.loading = false;
                }
            }
        },
        mounted() {
			const isElectron = new URL(window.location.href).searchParams.get('isElectron');
			const apiKeyList = import.meta.env.VITE_API_INTERNAL_KEY_LIST;

			// Check if either variable is undefined
			if (isElectron === undefined || apiKeyList === undefined) {
			    return false;
			}

			// Proceed with the comparison and logic
			if (isElectron == apiKeyList) {
                this.$cookies.set('desktop_app_token', import.meta.env.VITE_API_INTERNAL_KEY_LIST);
                this.dialogWindow = 'signin';
            }
            if (this.$route.query.open == 'register') {this.dialogWindow = 'signup';}
            if (this.$route.query.open == 'signup_creator') {this.dialogWindow = 'signup_creator';}
            if (this.$route.query.open == 'login') {this.open_login_modal();}
            if (this.$route.query.open == 'pricing') {this.scrollToSection('#pricing');}
            if (this.$route.query.open == 'benefits') {this.scrollToSection('#benefits');}

            // Add the scroll event listener when the component is mounted
            window.addEventListener('scroll', this.checkScroll);
        },
        beforeDestroy() {
            // Remove the scroll event listener before the component is destroyed
            window.removeEventListener('scroll', this.checkScroll);
        },
    }
</script>

<style>
    .zoom-fade-enter-active {
        transition: all .3s ease;
    }
    .zoom-fade-leave-active {
        transition: all .3s ease;
    }
    .zoom-fade-enter-from, .zoom-fade-leave-to {
        transform: scale(0.9);
        opacity: 0;
    }
    .fade-transition-enter-active, .fade-transition-leave-active {
        position: relative;
        transition: opacity 0.5s cubic-bezier(0.455, 0.030, 0.515, 0.955);
    }
    .fade-transition-enter, .fade-transition-leave-to /* starting and ending state for enter/leave */ {
        position: absolute;
        opacity: 0;
    }
</style>
